
import Vue from 'vue'
import EditProfileChangeButton from '@/components/account/EditProfileChangeButton.vue'
import RButton from '@/components/forms/RButton.vue'

export default Vue.extend({
  name: 'EditProfileSaveCancel',
  components: {
    EditProfileChangeButton,
    RButton,
  },
  props: {
    save: {
      type: Function,
      required: true,
    },
    cancel: {
      type: Function,
      required: true,
    },
    inProgress: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
})
